import PropTypes from 'prop-types';
import { ELEMENT__SHAPE_CSS } from '../elements/constants.elements';

export const PAGES__COPY = 'PAGES__COPY';
export const PAGES__CREATE = 'PAGES__CREATE';
export const PAGES__DELETE = 'PAGES__DELETE';
export const PAGES__FETCH = 'PAGES__FETCH';
export const PAGES__PATCH = 'PAGES__PATCH';
export const PAGES__REPLACE = 'PAGES__REPLACE';
export const PAGES__SORT = 'PAGES__SORT';
export const PAGES__UPDATE = 'PAGES__UPDATE';

export const PAGES__ROLE_FINALIZER = 'finaliser';
export const PAGES__ROLE_REDIRECTER = 'redirecter';
export const PAGES__ROLE_TERMINATION_FINALIZER = 'terminationFinaliser';
export const PAGES__ROLE_ERROR = 'error';

export const PAGES__SHAPE_ITEM = PropTypes.shape({
  conditionId: PropTypes.string,
  css: ELEMENT__SHAPE_CSS,
  id: PropTypes.string,
  position: PropTypes.number,
  terminating: PropTypes.bool,
  redirect: PropTypes.bool,
  redirectLink: PropTypes.string,
  type: PropTypes.oneOf(['Page']),
  version: PropTypes.number,
});
export const PAGES__SHAPE_ARRAY = PropTypes.arrayOf(PAGES__SHAPE_ITEM);
